/**
 * Copyright: ThoughtSpot Inc. 2021
 * Author: Chandershekhar Lhaniwal (Chandershekhar.luhaniwal@thoughtspot.com)
 *
 * @fileoverview Dialogue Alert for Radiant
 */
import _ from 'lodash';
import React from 'react';
import { Modal, ModalType } from '../../modal';
import { Typography } from '../../typography';
export const DialogueAlert = ({ isOpen = false, title, description, className = '', primaryButton, secondaryButton, onDismiss = _.noop, }) => {
    return (React.createElement(Modal, { title: title, variant: ModalType.Alert, isOpen: isOpen, includesHeader: !!title, autoScrollContent: false, confirmButton: primaryButton, dismissButton: secondaryButton, className: className, onDismiss: onDismiss }, description ? (React.createElement(Typography, { variant: "body-large", noMargin: true }, description)) : (undefined)));
};
//# sourceMappingURL=dialogue-alert.js.map